import React from 'react';
import { Icon, Button, Tabs, Tab, Stack } from '../index';
import './wizard.css';

/**
 * Step
 */
const Step = ({ prev, canPrev, next, canNext, ok, canOK, children}) => {

  const check = (canDoSomething) => {
    canDoSomething ? canDoSomething() : true
  }

  const prevButton = prev     ? <Button label="< PREV" action={prev}   /> : '';
  const nextButton = next     ? <Button label="NEXT >" action={next}   /> : '';
  const submitButton = ok     ? <Button label="OK"     action={ok}     primary /> : '';

  return (
    <div className="wizard-step">
      <main>
        {children}
      </main>
      <div className="wizard-action-bar">
        {submitButton}
        {nextButton}
        <span className="expand" />
        {prevButton}
      </div>
    </div>
  )
}


class Wizard extends React.Component {

  state = {
    tab: 0
  }

  changeTab = (tab) => {
    this.setState({ tab });
  }

  nextTab = () => {
    this.changeTab(this.state.tab + 1);
  }

  prevTab = () => {
    this.changeTab(this.state.tab - 1);
  }

  closeButton = this.props.closable ? <Icon className="close-button" icon="close" action={this.props.navigator.closeDialog} clickable/> : '';

  renderTabs = () => {
    const children = React.Children.toArray(this.props.children)
    return children.map( child => {
      return <Tab key={child.props.title} label={child.props.title} />
    })
  }

  renderSteps = () => {
    const children = React.Children.toArray(this.props.children)
    return children.map( child => {
      const wizardProps = {};
      if (child.props.prev) wizardProps.prev = this.prevTab;
      if (child.props.next) wizardProps.next = this.nextTab;
      return <Step key={child.props.title} {...child.props} {...wizardProps}>
        {child}
      </Step>
    })
  }

  render() {
    const onChangeTab = this.props.disableTabs ? console.log : this.changeTab;
    return (
      <div className="wizard">
        {this.closeButton}
        <h1>{this.props.title}</h1>
        <h2>{this.props.subtitle}</h2>
        <Tabs className="wizard-steps" selected={this.state.tab} onChange={onChangeTab}>
          {this.renderTabs()}
        </Tabs>
        <Stack selected={this.state.tab}>
          {this.renderSteps()}
        </Stack>
      </div>
    )
  }
}

export { Wizard, Step };



// WEBPACK FOOTER //
// ./src/lib/components/wizard.js